// Helper za auth redirect-e (auth.grozd.me <-> erp/admin.grozd.me)
//
// AUTH_URL detekcija (po prioritetu):
//  1) window.__GROZD_AUTH_URL__ (dev/test override)
//  2) process.env.NEXT_PUBLIC_AUTH_URL (build-time u Next.js)
//  3) hostname fallback: *.dev.grozd.me → dev auth, inače prod
//
// Prije fix-a: fallback je bio hardcoded "https://auth.grozd.me" (prod),
// pa je dev ERP/Admin redirektovao na prod auth — cookie cross-pollution.

function resolveAuthUrl(): string {
  if (typeof window !== "undefined") {
    const override = (window as any).__GROZD_AUTH_URL__;
    if (override) return override;
  }
  const envUrl = process.env.NEXT_PUBLIC_AUTH_URL;
  if (envUrl) return envUrl;
  if (typeof window !== "undefined" && window.location.hostname.endsWith(".dev.grozd.me")) {
    return "https://auth.dev.grozd.me";
  }
  return "https://auth.grozd.me";
}

export function redirectToLogin(returnTo?: string): void {
  if (typeof window === "undefined") return;
  const target = returnTo || window.location.href;
  const url = `${resolveAuthUrl()}/login?return_to=${encodeURIComponent(target)}`;
  window.location.href = url;
}

export function redirectToReturn(): void {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const returnTo = params.get("return_to") || "/";
  // Validacija: dozvoli samo *.grozd.me domene
  try {
    const url = new URL(returnTo);
    if (!url.hostname.endsWith(".grozd.me") && url.hostname !== "grozd.me") {
      window.location.href = "/";
      return;
    }
    window.location.href = returnTo;
  } catch {
    window.location.href = "/";
  }
}
